import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { ToasterService } from "../../../services/toaster/toaster.service";
import { hallsAPI } from "../api/api";
import { HallsActionTypes } from "../actions/actionTypes";

function* updateHall(action) {
    try {
        const hallID = action.payload.hallId;
        const hall = yield call(() =>
            hallsAPI.updateHall(hallID, action.payload.newState)
        );

        yield put({
            type: HallsActionTypes.UPDATE_HALL_SUCCESS,
            payload: hall.data
        });

        if (action.payload.hallName != action.payload.newState.name) {
            ToasterService.successToast(
                "Hall successfully updated. Since the name has changed, please validate/edit names of active servers."
            );
        } else {
            ToasterService.successToast("Hall successfully updated.");
        }

        yield put({
            type: HallsActionTypes.GET_HALL,
            payload: {
                hallId: hallID
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error updating hall.");

        yield put({
            type: HallsActionTypes.UPDATE_HALL_FAIL
        });
    }
}

export function* updateHallWatcher() {
    yield takeLatest(HallsActionTypes.UPDATE_HALL, updateHall);
}
